import type { Metadata } from "next";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { WeaponCatalog } from "@/components/WeaponCatalog";
import { CALIBRES } from "@/lib/data";

export const metadata: Metadata = {
  title: "Locations",
  description: "Catalogue d’armes en location pour les licenciés STO.",
};

export default function LocationsPage() {
  return (
    <>
      <PageHero
        kicker="Parc club"
        title="18 armes. Prix club."
        lead="Poing et longues, pour tout licencié STO. Idéal avant les 6 mois de détention catégorie B. Casque et lunettes fournis. Cliquez une arme."
      />
      <section className="px-5 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <Reveal>
            <p className="mb-10 max-w-2xl text-mute">
              Calibres : {CALIBRES.join(" · ")}. Dernière arrivée : Ruger PC Carbine
              9 mm. La location reste au stand, sous les règles du club.
            </p>
          </Reveal>
          <WeaponCatalog />
        </div>
      </section>
    </>
  );
}
